// extracted by mini-css-extract-plugin
export default {"container":"stickyBar_container__3Pk9f"};